<div class="modal-container">
    <ion-header>
        <ion-toolbar>
            <ion-buttons slot="start">
                <ion-button (click)="dismiss()" color="light">
                    <ion-icon slot="icon-only" class="icon haleo-close"></ion-icon>
                </ion-button>
            </ion-buttons>
            <ion-title>
                {{'thoughtRecord.assessment.addEmotion' | translate}}
            </ion-title>
        </ion-toolbar>
    </ion-header>
    <div class="content">
        <ion-button *ngFor="let option of options" size="small" (click)="selectOption(option)">
            {{option.label}}
        </ion-button>
    </div>
</div>
